import _ from 'lodash';
import PropTypes from 'prop-types';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';
import ToggleGroupButton from 'v3/common/components/ToggleGroupButton';

const propTypes = {
  tradingType: PropTypes.string.isRequired,
  onChangeTradingType: PropTypes.func.isRequired,
};
const defaultProps = {};

const TRADE_TYPES = {
  positional: 'positional',
  intraday: 'intraday'
};

const ExpirySelector = ({ tradingType, onChangeTradingType }) => {

  const { positional, intraday } = TRADE_TYPES;

  const toggleOptions = [
    {
      label: _.startCase(intraday),
      value: intraday,
      disabled: ApplicationDomainUtility.isCrypto,
    },
    {
      label: _.startCase(positional),
      value: positional,
      // disabled: false,
    },
  ];
  return (
    <div className="trade-type mb-4">
      <div className="row align-items-center">
        <div className="col-md-2">
          <label className="label_style">Trade Type</label>
        </div>
        <div className="col-md-10">
          <ToggleGroupButton
            options={toggleOptions}
            defaultValue={tradingType}
            onChange={(newTradingType) => {
              const isDisabled = toggleOptions.find((option) => option.value === newTradingType).disabled;
              return isDisabled ? null : onChangeTradingType(newTradingType);
            }}
            name="tradingType"
          />
        </div>
      </div>
    </div>
  );
};

ExpirySelector.propTypes = propTypes;
ExpirySelector.defaultProps = defaultProps;

export default ExpirySelector;
